import LinkButton from 'components/common/link-button/LinkButton';
import withRedirectToOutsideApp from 'components/common/with-redirect-to-outside-app/withRedirectToOutsideApp';
import { ANALYTIC_FEATURES, FeatureFlagNames } from 'constants/app.constant';
import { EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { isEnabledMockService } from 'helpers/app.helper';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { appSelectors } from 'redux/ducks/app';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { isEAQStandalone } from 'reports/cw/services/courses.service';
import { trackAAFeature } from 'services/adobe-analytics.service';
import { isEABAppByAppName } from 'services/app-linking.service';
import { isFeatureEnabled } from 'services/feature-flag.service';
var CWCourseContext = function (_a) {
    var currentCourseName = _a.currentCourseName, onRedirectToOutsideApp = _a.onRedirectToOutsideApp;
    var history = useHistory();
    var breadcrumbBackTitle = useSelector(appSelectors.getBreadcrumbBackTitle);
    var courseSectionInfo = useSelector(courseSelectors.getCourseSectionInfo);
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var isMockServiceEnabled = isEnabledMockService();
    var enableEaqPerformanceAppRedirect = isFeatureEnabled(featureFlags, FeatureFlagNames.ENABLE_EAQ_PERFORMANCE_APP_REDIRECT);
    var handleViewAllCourse = function () {
        trackAAFeature(ANALYTIC_FEATURES.CW_INSTRUCTOR_HOME_VIEW_ALL_COURSES_CLICK);
        history.push(PerformancePath.courseAggregate);
    };
    var handleViewMyCoursePlan = function () {
        if (!isMockServiceEnabled) {
            trackAAFeature(ANALYTIC_FEATURES.CW_INSTRUCTOR_HOME_VIEW_MY_COURSE_PLAN_CLICK);
            var linkConfig = {
                appName: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.APP_NAME,
                action: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.ACTION.PERFORMANCE_VIEW
            };
            onRedirectToOutsideApp(linkConfig);
        }
    };
    var shouldShowViewMyCoursePlanButton = !isEABAppByAppName(breadcrumbBackTitle) && (enableEaqPerformanceAppRedirect || !isEAQStandalone(courseSectionInfo));
    return (<div className="u-max-width-1400 u-els-padding-left-1x1o2 u-els-padding-right-1x1o2 c-cw-course-context__wrapper">
      <div className="c-cw-course-context">
        <div className="c-cw-course-context__info">
          <div className="c-cw-course-context__course">
            <span className="c-cw-course-context__label">Viewing Course: </span>
            <span className="c-cw-course-context__name">{currentCourseName}</span>
          </div>
          {shouldShowViewMyCoursePlanButton && (<LinkButton onClick={handleViewMyCoursePlan} className="c-cw-course-context__plan-link" disabled={isMockServiceEnabled}>
              View My Course Plan
            </LinkButton>)}
        </div>
        <LinkButton onClick={handleViewAllCourse} className="c-cw-course-context__view-all-button">
          View all Courses
        </LinkButton>
      </div>
    </div>);
};
export { CWCourseContext as CWCourseContextBase };
export default withRedirectToOutsideApp(CWCourseContext);
